// extracted by mini-css-extract-plugin
export var settingsList = "_3n-0";
export var settingsRow = "_3n-1";
export var warningDot = "_3n-2";